import { render } from "./TraitRanksClues.vue?vue&type=template&id=0f76e1ef"
import script from "./TraitRanksClues.vue?vue&type=script&lang=js"
export * from "./TraitRanksClues.vue?vue&type=script&lang=js"

import "./TraitRanksClues.vue?vue&type=style&index=0&id=0f76e1ef&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__